import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const items = [
  {
    q: "How long does it take to build my website?",
    a: "Most builds are completed in 2–5 days from kickoff. Larger e-commerce projects may take 10–15 days.",
  },
  {
    q: "Is web hosting included?",
    a: "Yes — hosting, SSL, maintenance, and support are all included for the full 12-month term of your plan. You only need to provide your own domain name (e.g. from GoDaddy or Namecheap) so it always stays in your name. We handle the full setup: DNS, SSL, and deployment.",
  },
  {
    q: "What happens after my 12 payments?",
    a: "Once all 12 payments are complete, the finished website code belongs to you. You won't be automatically charged the website payment again. If you'd like us to keep hosting and maintaining it, you can choose an optional month-to-month Website Care plan (Starter $49, Business $79, Premium $99) and cancel anytime.",
  },
  {
    q: "Do you write the website copy?",
    a: "We provide proven copy templates and edit the wording with you. Full copywriting is available as an add-on.",
  },
  {
    q: "Can I take my site somewhere else later?",
    a: "Absolutely. After your 12 payments are complete, you own the code and your domain — no lock-in. Major redesigns, new pages, new functionality, e-commerce additions, or third-party integrations are quoted separately.",
  },
  {
    q: "How do payments work?",
    a: "Your first monthly payment is made today via secure Stripe checkout, which clearly shows it's the first payment of a 12-month plan. You then pay the same monthly amount for 12 months. These are 12-month agreements — if ended early, the remaining balance becomes due.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="section-pad relative bg-[#070707]">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="font-mono-jb text-xs uppercase tracking-[0.3em] text-[#CCFF00]">
            / FAQ
          </span>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tighter font-bold mt-4">
            Common questions, <span className="text-gradient-neon">answered.</span>
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-[#111] border border-[#27272A] rounded-2xl px-6 hover:border-[#CCFF00]/40 transition-colors"
            >
              <AccordionTrigger className="font-display text-lg text-left hover:text-[#CCFF00] hover:no-underline">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
